export default __webpack_public_path__ + "static/media/Prathamesh.29c9c41f.png";